
const Player = ({player, setOpened, setNewPlayer})=>{

    const openCard =(newPlayer)=>{
        
        setOpened(true)
        setNewPlayer(newPlayer)
    
    }
   
    return(

  
            <tr onClick={()=>openCard(player)}>
               
                    <td>{player.name}</td>
                    <td>{player.team.name}</td>
                    <td>
                    {player.positions.map((position, index, array)=>
                        index !== array.length - 1 ? `${position}, ` : (position)
                    )}
                    
                    </td>
               
            </tr>
        
    )
}

export default Player